<template>
  <div :style="wrapperStyleObj">
    <yx-auto-complete
      :width="width"
      :api="api.getStudentList"
      :placeholder="placeholder"
      :no-page="true"
      :keys="{ searchKey: 'queryKey' }"
      :query-params="{
        displayHistory: displayHistory,
        intentionStatus: intentionStatus,
        scene: 0,
        campusIds,
        status: status || [],
        page: {
          pageNum: 0,
          pageSize: 100,
        },
      }"
      :display-format="displayFormat"
      :immediate="immediate"
      @select="(arg) => $emit('select', arg)"
      @clear="() => $emit('clear')"
      :appendFlag="appendFlag"
      ref="yxRef"
    ><template #append v-if="appendFlag"><slot name="append"></slot></template></yx-auto-complete>
  </div>
</template>

<script>
import { defineComponent, ref, inject } from 'vue';

export default defineComponent({
  name: 'StudentSelector',
  props: {
    wrapperStyleObj: {
      type: Object,
      default() {
        return {};
      },
    },
    width: {
      type: String,
      default: '192px',
    },
    placeholder: {
      type: String,
      default: '学员姓名/手机号码',
    },
    format: Boolean,
    immediate: {
      type: Boolean,
      default: true,
    },
    initCampus: {
      type: Array,
    },
    intentionStatus: {
      type: [Number, String],
      default: '',
    },
    displayHistory: {
      type: Boolean,
      default: false,
    },
    // 是否在读
    status: {
      type: Array,
    },
    appendFlag: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const yxRef = ref(null);
    // const campusIds = inject('campus');
    const injectCampus = inject('campus');
    const campusIds = ref(props.initCampus || injectCampus);

    return {
      yxRef,
      // campusIds: props.initCampus || campusIds,
      campusIds,
      displayFormat(it) {
        const item = it;
        if (props.format) {
          return `${item.name}-${item.phone}`;
        }
        return `${item.name}`;
      },
      clearField() {
        yxRef.value.clearField();
      },
      setField(str) {
        yxRef.value.setField(str);
      },
      setInitCampus(arr) {
        campusIds.value = arr;
      },
    };
  },
});
</script>
